module.exports = __webpack_public_path__ + "img/0706-珠宝类-下-02.2d4f991a.png";